import React from "react";
import styles from "../../static/css/pages.module.css";
import Input from "../../components/form/input/input";
import Button from "../../components/form/button/button";
import Modal from "../../components/modal/modal";
import InputMail from "../../components/form/input/input_mail";
import {connect} from "react-redux";
import * as consts from "../../store/constants/sendData";
import {postDataAction} from "../../store/actions/postDataAction";
import ieSvg from "../../components/icons/ieSvg";
import Dropdown from "../../components/form/dropdown/dropdown";

class RegisterClientForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      type: '',
      clientInn: '',
      clientName: '',
      clientService: '',
      clientMail: ''
    };
  }

  componentDidMount() {
    ieSvg();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.type !== this.state.type) {
      if (this.state.clientInn) {
        const clientInn = document.getElementById('clientInn');
        const inputEvent = new Event('input', {bubbles: true});
        clientInn.dispatchEvent(inputEvent);
      }
    }
  }

  selectChange = (e) => {
    this.setState({ type: e.value });
  };

  handleState = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value,
    })
  }

  handleSubmit = (e) => {
    let form = e.target.closest("button");
    let formData = {
      email: this.state.clientMail,
      inn: this.state.clientInn,
      name: this.state.clientName,
      serviceName: this.state.clientService,
    }
    let path;
    switch (this.state.type) {
      case 'PHYSICAL': path = 'physical/add';
      break;
      case 'INDIVIDUAL': path = 'individual/add';
        break;
      default: path = 'jurperson/add';
    }
    this.props.fetchData(process.env.REACT_APP_GATE + path, this, consts.JURPERSON_ADD, formData, form);
  }

  handleClose = () => {
    this.props.fetchData('', this, consts.JURPERSON_ADD);
    localStorage.setItem("fDataRefresh", 'true');
    document.querySelector("[data-menu='clients']").click();
    // let hideButton = document.getElementById('form-hide');
    // if (hideButton) {
    //   hideButton.click()
    // }
    let reloadButton = document.getElementById('reload-clients');
    if (reloadButton) {
      reloadButton.click()
    }
  }

  renderDialog(param) {
    switch (param) {
      case "ERROR":
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_error"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Клиент не зарегистрирован"
          body={<div className={styles.article}>
            {this.props.data.items.result.errorMessage}
            <div className={styles.article}></div>
          </div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />;
      case "TIMEOUT":
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_error"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Клиент не зарегистрирован"
          body={<div className={styles.article}>
            Сервис временно недоступен
            <div className={styles.article}></div>
          </div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />;
      case "SUCCESS":
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_success"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Клиент добавлен"
          body={<div className={styles.article}>
            Информацию о клиенте можно посмотреть в разделе <span className={styles.link} onClick={this.handleClose}>«Мои Клиенты»</span>.<br />
            <div className={styles.article}></div>
          </div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />
      default:
        return null;
    }
  }

  render() {
    this.innLength = this.state?.type === 'JURIDICAL' ? '10' : '12';
    return (
      <div data-form>
        <div>
          <div className="l-grid">
            <div className="l-grid__item_6">
              <Dropdown label="Выберите группу" name="type" onChange={this.selectChange}
                        placeholder="" required items={[
                { value: 'PHYSICAL', label: 'физическое лицо' },
                { value: 'JURIDICAL', label: 'юридическое лицо' },
                { value: 'INDIVIDUAL', label: 'индивидуальный предприниматель' },
              ]} />
            </div>
            <div className="l-grid__item_6">
              <Input label="ИНН клиента" required length={this.innLength}
                     maxlength={this.innLength}
                     onChange={this.handleState}
                     value={this.state.clientInn} name="clientInn"
                     dataNumber
                     disabled={!this.state.type}
                     id='clientInn'
                     key={this.state.type}
              />
            </div>
          </div>
          <Input label="Наименование клиента" onChange={this.handleState} maxlength="160" name="clientName" value={this.state.clientName} />
          <Input label="Услуга" onChange={this.handleState} maxlength="256" required name="clientService" value={this.state.clientService} />
          <InputMail label="Е-mail клиента" name="clientMail" maxlength="100" value={this.state.clientMail} onChange={this.handleState} required />
        </div>
        <div className="l-align_right">
          <Button title="Добавить клиента" onClick={this.handleSubmit} />
        </div>
        <div>
          {this.props.data.items ?
            this.renderDialog(this.props.data.items.result.status)
            :
            null
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({data: state.jurpersonAdd})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types, body, el) => dispatch(postDataAction(url, parent, types, body, el))}
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterClientForm);